// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1awMS","header":"ReportDetails_header__hu7PP","title":"ReportDetails_title__2i_R2","left":"ReportDetails_left__2oY3v"};